module.exports = __webpack_public_path__ + "static/media/instagram.a2218872.svg";